import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined';
import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';

/** User-facing chart types — maps to backend question_type + visualization internally */
export const CHART_TYPES = Object.freeze([
  {
    id: 'number',
    label: 'Number',
    description: 'One total — e.g. 128 leads',
    Icon: LooksOneOutlinedIcon,
  },
  {
    id: 'line',
    label: 'Line chart',
    description: 'Trend over time — e.g. leads per day',
    Icon: ShowChartOutlinedIcon,
  },
  {
    id: 'bar',
    label: 'Bar chart',
    description: 'Compare groups side by side',
    Icon: BarChartOutlinedIcon,
  },
  {
    id: 'pie',
    label: 'Pie chart',
    description: 'Share of each category',
    Icon: PieChartOutlineOutlinedIcon,
  },
  {
    id: 'table',
    label: 'Table',
    description: 'Detailed rows for the columns you choose',
    Icon: TableChartOutlinedIcon,
  },
]);

export const DEFAULT_CHART_TYPE = 'number';

export const TIME_FIELD_OPTIONS = Object.freeze([
  { id: 'created_at', label: 'Created date' },
]);
